<ng-template #defaultFooter>
  <div class="d-flex">
    <div class="flex-fill d-none d-md-inline">
      <div class="d-flex">
        <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
        <div class="flex">
          <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
            class="form-control form-select custom-select" aria-label=""
            (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
            <option [ngValue]="250">250</option>
          </select>
        </div>
      </div>
    </div>
    <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
      <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!" [(page)]="tableFunctions.page"
        [pageSize]="tableFunctions.pageSize" [maxSize]="tableFunctions.page == 4 ? 4 : 3" [boundaryLinks]="true"
        [rotate]="true">
      </ngb-pagination>
    </div>
    <div class="flex-fill justify-content-end d-none d-md-inline">
      <div class="d-flex float-end">
        <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
        <div class="flex">
          <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
            aria-label="">
            <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1
              }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<main id="evaluation">
  <div class="card">
    <nav>
      <div id="nav-tab" role="tablist">
        <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
          <li class="nav-item" [ngbNavItem]="'delivery-notes'" *ngIf="permissions?.evaluationDeliveryNotes" domId="tab_delivery_notes">
            <a class="nav-link me-2 ps-2" ngbNavLink routerLink="delivery-notes" routerLinkActive="active">
              <app-svg source="icons/feather/file-text" height="18"></app-svg>
              <span i18n="@@DeliveryNoteTab">Lieferscheine</span>
            </a>
          </li>

          <li class="nav-item" [ngbNavItem]="'charging-statistics'" domId="tab_charging_statistics">
            <a class="nav-link me-2 ps-2" ngbNavLink routerLink="charging-statistics" routerLinkActive="active">
              <app-svg source="icons/feather/bar-chart" height="18"></app-svg>
              <span i18n="@@ChargingStatisticsTab">Ladestatistik</span>
            </a>
          </li>

          <li class="nav-item" [ngbNavItem]="'transactions'" domId="tab_transactions" *ngIf="permissions?.evaluationTransactions">
            <a class="nav-link me-2 ps-2" ngbNavLink routerLink="transactions" routerLinkActive="active">
              <app-svg source="icons/feather/zap" height="18"></app-svg>
              <span i18n="@@ChargingTransactionsTab">Ladevorgänge</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="card">
      <div class="card-body">
        <div class="tab-content mt-2" id="nav-tabContent">
          <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
        </div>
      </div>
    </div>

    <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }" *ngIf="activeTab != 'charging-statistics'">
      <ng-container *ngTemplateOutlet="defaultFooter"></ng-container>
    </div>
  </div>
</main>
